import React, { useState } from 'react';

import { Button, DialogActions, DialogContent, FormControlLabel, Grid, Radio, RadioGroup } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import { isSupported as isBrowserSupported } from 'twilio-video';

import DialogHeader from 'components/DialogHeader';
import { useStyles } from 'components/DialogVideoOnDemandSessionCreation/components/SessionTypeStep/SessionTypeStep.useStyles';
import {
  FORM_NAME,
  SESSION_TYPE,
} from 'components/DialogVideoOnDemandSessionCreation/DialogVideoOnDemandSessionCreation';
import TelehealthBrowserNotSupportedBanner from 'components/TelehealthBrowserNotSupportedBanner';

interface SessionTypeStepProps {
  classes: any;
  formProps: any;
  onClose: () => void;
}

const SessionTypeStep: React.FC<SessionTypeStepProps> = ({
  classes,
  formProps: { setFieldValue, isSubmitting },
  onClose,
}) => {
  const [isVideo, setVideo] = useState('');

  const radioOption = (value: string, label: string) => (
    <FormControlLabel
      classes={{ label: classes.text }}
      key={value}
      value={value}
      control={
        <Radio
          data-lh-id={`telehealth-on-demand-session-type-${value}`}
          color="primary"
          icon={<RadioButtonUncheckedIcon color="primary" />}
          checkedIcon={<RadioButtonCheckedIcon color="primary" />}
        />
      }
      label={label}
    />
  );

  return (
    <>
      <DialogHeader title="What type of on demand session do you want with this patient?" onRequestClose={onClose} />
      {isVideo === SESSION_TYPE.video && <TelehealthBrowserNotSupportedBanner />}
      <DialogContent className={classes.content}>
        <Grid container spacing={16}>
          <Grid item xs={12}>
            <RadioGroup
              defaultValue={SESSION_TYPE.telehealth}
              onChange={(_, value) => {
                setFieldValue('sessionType', value);
                setVideo(value);
              }}
            >
              {radioOption(SESSION_TYPE.telehealth, 'Telehealth visit with a provider')}
              {radioOption(SESSION_TYPE.video, 'Video call')}
            </RadioGroup>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          data-lh-id="telehealth-on-demand-session-creation-cancel-button"
          color="primary"
          onClick={onClose}
          variant="text"
        >
          Cancel
        </Button>
        <Button
          color="primary"
          form={FORM_NAME}
          type="submit"
          variant="contained"
          data-lh-id="telehealth-on-demand-session-creation-next-button"
          disabled={isSubmitting || (!isBrowserSupported && isVideo === SESSION_TYPE.video)}
        >
          Next
        </Button>
      </DialogActions>
    </>
  );
};

export default withStyles(useStyles)(SessionTypeStep);
